<script>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import { onMounted, ref } from 'vue'
import { getUserTotalScore } from '@/api/person'
import { useRoute } from 'vue-router'
import router from '@/router'
import { getQueryString } from '@/utils/tools'

export default {
  setup() {
    const store = useStore()

    const userInfo = computed(() => store.getters.getUser)

    onMounted(async () => {
      await fetchUserTotalScore()
    })

    const route = useRoute()
    const userTotalScore = ref('')

    // 获取用户总积分
    const fetchUserTotalScore = async () => {
      const res = await getUserTotalScore({
        token: store.getters.getToken,
        questionActiveKey: route.query.questionActiveKey
      })



      if (res.ok) {
        userTotalScore.value = res.data
      }
    }

    const scoreList = () => {
      // router.push('/person/recordScoreList')

      router.push({
        path: '/person/recordScoreList',
        query: {
          ...route.query
        }
      })
    }

    const orgid = getQueryString('orgid')

    return {
      orgid,
      userInfo,
      userTotalScore,
      scoreList
    }
  }
}
</script>
<template>
  <div class="info-wrap">
    <div style='display: flex;flex-direction: row;align-items: center'>
      <img
        v-if="!userInfo?.avatar"
        class="avatar"
        src="@/assets/img/person/avatar.png"
      />
      <img v-else class="avatar" :src="userInfo?.avatar" alt="" />
      <p class="name">{{ userInfo?.nickname }}</p>
    </div>
    <p v-if="orgid != '21'" class="score" @click='scoreList'>积分：{{ userTotalScore }}<img class='img' src='~@/assets/img/person/jiantouyou.png' alt=''></p>
  </div>
</template>
<style lang="scss" scoped>
.info-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: 700px;
  min-height: 160px;
  background: no-repeat top/100% url('~@/assets/img/person/info-bg.png');

  .avatar {
    margin-left: 28px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #777;
    object-fit: cover;
  }

  .name {
    margin-left: 25px;
    font-size: 32px;
    font-weight: bold;
    color: #ffffff;
  }

  .score {
    margin-right: 15px;
    font-size: 32px;
    font-weight: bold;
    color: #ffffff;
  }
}

.img {
  width: 30px;
  height: 25px;
  margin-left: 10px;
  object-fit: contain;
}
</style>
